import React, {PropTypes} from 'react';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import addTripsActions from './add_trips_actions';
import './add_trips.less'
import DashBoardHeader from '../header_dashboard/dashboard_header';
import InputComponent from '../components/input_component/input_component';
import LocationInput from '../components/location_auto_search/location_auto_search'
import LoggedinFooter from '../footer/loggedin_footer';
import ShowError from '../components/error/show_error';
import validate from '../util/validate';
import {toTitleCase,join,localTimestampToGMT,GMTTimeStampToLocal} from '../util/common';
import moment from 'moment';
import {Link, browserHistory} from 'react-router';
import CONSTANTS from '../common_constants';
import DateTimePicker from 'react-datetime';
import './date_picker.less'
import ConfirmDeleteComponent from '../components/confirm_box/confirm_box';
import browsePackagesAction from '../browse_packages/browser_packages_actions';

const yesterday = DateTimePicker.moment().subtract( 1, 'day' );

const disablePrevDates = (current) => {
    return current.isAfter( yesterday );
  }
class AddTripDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addTrip : {},
      editMode : false,
      showTOBrowseShipments : false
    }
  }
  componentDidMount(){
    let tripId = this.props.location.query.id;
    let allTrips = this.props.addTrips.allTrips;
    if(allTrips.length > 0)
    {
      if(tripId)
      {
        let currentTrip = allTrips.filter((trip , key) => {
          return trip.tripId == tripId;
        })
        if(currentTrip && currentTrip.length > 0)
        {
          let addTrip = Object.assign({},this.state.addTrip)
          addTrip = currentTrip[0];
          // addTrip.flightDate = GMTTimeStampToLocal(addTrip.flightDate)
          this.setState({
            addTrip,
            editMode : true
          })
        }else{
          this.setState({
            editMode: false
          })
        }
      }else{
        this.setState({
          editMode: false
        })
      }
    }else{
      this.setState({
        editMode: false
      })
    }
  }
  changeHandler = (type , value) =>{
      let addTrip = Object.assign({} , this.state.addTrip);
      if(type == "departure")
      {
        if(value)
        {
          addTrip.destinationLat = value.location.lat;
          addTrip.destinationLong = value.location.lng;
          addTrip.destinationLocation = value.label ;
          addTrip.destinationCountry = value.country;
          addTrip.destinationCountryCode = value.countryCode;
          addTrip.destinationCity = value.cityName;
          addTrip.destinationLandmark = value.landMark;
        }else{
          addTrip.destinationLat = null;
          addTrip.destinationLong = null;
          addTrip.destinationLocation = null;
          addTrip.destinationCountry = null;
          addTrip.destinationCountryCode = null;
          addTrip.destinationCity = null;
          addTrip.destinationLandmark = null;
        }
      }else if (type == "arrival") {
        if(value)
        {
          addTrip.arrivalLat = value.location.lat;
          addTrip.arrivalLong = value.location.lng;
          addTrip.arrivalLocation = value.label ;
          addTrip.arrivalCountry = value.country;
          addTrip.arrivalCountryCode = value.countryCode;
          addTrip.arrivalCity = value.cityName;
          addTrip.arrivalLandmark = value.landMark;
        }else{
          addTrip.arrivalLat = null;
          addTrip.arrivalLong = null;
          addTrip.arrivalLocation = null;
          addTrip.arrivalCountry = null;
          addTrip.arrivalCountryCode = null;
          addTrip.arrivalCity = null;
          addTrip.arrivalLandmark = null;
        }
      }else{
        addTrip[type] = value;
      }
      this.setState({
          addTrip
      })
  }
  dateChanged = (date) =>{
    let addTrip = Object.assign({} , this.state.addTrip)
    if(date._isAMomentObject)
    {
      addTrip.flightDate = date.unix()*1000
      this.setState({
        addTrip
      })
    }else{
        addTrip.flightDate = null;
        this.setState({
          addTrip
        })
    }
  }
  submit = (e) =>{
      e.preventDefault();
      this.setState({error:null});
      const self = this;
      const validationError = {
          destinationLocation: !validate.name(this.state.addTrip.destinationLocation),
          arrivalLocation: !validate.name(this.state.addTrip.arrivalLocation),
          flightDate: !moment(this.state.addTrip.flightDate).isValid()
      };
      const validationMap = {
          destinationLocation: 'Departure Location',
          arrivalLocation: 'Arrival Location',
          flightDate: 'Flight Date'
      };
      let errorMsg = "";
      const validationFields = [];
      Object.keys(validationError).forEach((key) => {
          if (validationError[key])
              validationFields.push(validationMap[key]);
          }
      );
      if (validationFields.length) {
          errorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
              if (validationFields.length === 1)
                  return "";
              if (idx > 0 && idx < validationFields.length - 1)
                  return ", ";
              else if (idx === validationFields.length - 1)
                  return " and ";
              return "";
          }) + '.';
      }
      if(errorMsg){
        this.setState({
          error : errorMsg,
          validationError : validationError
        });
        return;
      }
      let params = Object.assign({} , this.state.addTrip);
      this.setState({
        ajaxInProgress : true
      })
      // params.flightDate = localTimestampToGMT(params.flightDate)
      const {userData} = this.props.authState;
      if(!this.state.editMode)
      {
        this.props.addTripsActions.addTrip(params).then((data) => {
          if(userData.email) amplitude.getInstance().setUserId(userData.email);
          amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.NEW_TRIP_ADDED);

          this.setState({
            ajaxInProgress : false
          })
          if(data.count > 0){

            if(userData.email) amplitude.getInstance().setUserId(userData.email);
            amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.MYTRIPS_MATCHING_SHIPMENT_FOUND);

            this.setState({
            showTOBrowseShipments : true
          })
          }else{
              browserHistory.push('/my-trips');
          }
        }, (errorRes) => {
            if(errorRes.error === CONSTANTS.sessionInvalid){
                  this.setState({ajaxInProgress: false})
                  this.props.authActions.sessionValid(false);
                  cookies.delete('_sd');
                  return ;
          }
            this.setState({ajaxInProgress: false,successMsg:""});
            this.setState({error: errorRes.error, validationError: validationError});
        })
      }else{
        this.props.addTripsActions.updateTrip(params).then((data) => {
          if(userData.email) amplitude.getInstance().setUserId(userData.email);
          amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.MYTRIP_UPDATED);

          this.setState({
            ajaxInProgress : false
          })
            if(data.count > 0){
              this.setState({
              showTOBrowseShipments : true
            })
          }else{
              browserHistory.push('/my-trips');
          }
        }, (errorRes) => {
            if(errorRes.error === CONSTANTS.sessionInvalid){
                  this.setState({ajaxInProgress: false})
                  this.props.authActions.sessionValid(false);
                  cookies.delete('_sd');
                  return ;
          }
            this.setState({ajaxInProgress: false,successMsg:""});
            this.setState({error: errorRes.error, validationError: validationError});
        })
      }
  }
  goBack = () =>{
    if(this.state.editMode)
    {
        browserHistory.push('/my-trips');
    }else {
        browserHistory.push('/dashboard');
    }
  }
  hideConfirmBox = () =>{
    browserHistory.push('/my-trips');
  }
  showShipments = () =>{
    this.props.browsePackagesAction.enableTrips();
    browserHistory.push('/browse-shipments');
  }
  render() {
    let addTrip = this.state.addTrip;
    const editMode = this.state.editMode;
    let title = 'Enter Trip Details';
    if(editMode)
    {
      title = "Edit Trip details"
    }

    return (
      <div id="addTripDetails">
        <div className = "wrapper add-trip-details-wrap">
          <ConfirmDeleteComponent
            onConfirmCallback = {this.showShipments}
            closePopupCallback = {this.hideConfirmBox}
            header = "Confirm"
            description = "There are shipments that match your trip. Would you like to view them?"
            popupState = {this.state.showTOBrowseShipments}/>
          <div className="back-section" onClick = {this.goBack}>
              <span className="icon-icn_back"></span>
              <span className = "back-content">Back</span>
          </div>
          <div className = "add-trip-details">
            {this.state.ajaxInProgress && <div className = "loader-wrapper"><div className = "loader"></div></div>}
            <div className ="error-section">
              {this.state.error && <ShowError errorMessage = {this.state.error} />}
            </div>
            <div className = "heading">
                {title}
            </div>
            <div className ="input-details-wrap">
              <div className = "input-details">
                <LocationInput value = {addTrip.destinationLocation}title = "Departure City" placeholder ="Where are you coming from" for ="departure" changeHandler = {this.changeHandler}/>
              </div>
              <div className = "input-details">
                <LocationInput value = {addTrip.arrivalLocation} title = "Arrival City" placeholder ="Choose your destination" for ="arrival" changeHandler = {this.changeHandler}/>
              </div>
              <div className = "input-details">
                <div className = "label">Date</div>
                <DateTimePicker  isValidDate = {disablePrevDates}value = {addTrip.flightDate} onChange = {this.dateChanged} inputProps = {{placeholder : "When are you going"}}/>
              </div>
              <div className = "input-details">
                <InputComponent type="text" dollar ={false}value = {addTrip.flightNo} title = "Flight Number" placeholder = "Flight Number (Optional)" for ="flightNo" changeHandler = {this.changeHandler}/>
              </div>
            </div>
            <div className = "submit-section">
              <div className = "submit-options">
                  <button className = "btn orange" onClick = {this.submit} >Save</button>
              </div>
            </div>
          </div>
        </div>
        <LoggedinFooter />
      </div>

    )
  }
}


class AddTrips extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const self = this;
    const {props, state} = this;
    let sessionValid = true ;
    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid

    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };

    if(props.authState) {
      user.name = props.authState.userData.name;
      user.imageUrl = props.authState.userData.profileImageUrl;
      user.isVerified = props.authState.userData.isVerified;
    }
    return (
      <div className = "add-trip-wrap">
          <DashBoardHeader user = {user} logout={this.logout}/>
          <div className = "d-header-wrap">
            <div className = "wrapper">
              <h2 className = "page-header d-page-header">Trip</h2>
            </div>
          </div>
          <AddTripDetails
            addTrips = {this.props.addTrips}
            location = {this.props.location}
            authActions = {this.props.authActions}
            authState = {this.props.authState}
            addTripsActions = {this.props.addTripsActions}
            browsePackagesAction = {this.props.browsePackagesAction}/>
      </div>
    )
  }
}

AddTrips = connect((state) => {
  return {
    addTrips : state.app.addTrips,
    authState: state.app.auth,
    browsePackages: state.app.browsePackages
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch),
    addTripsActions :bindActionCreators(addTripsActions, dispatch),
    browsePackagesAction: bindActionCreators(browsePackagesAction, dispatch)
  }
})(AddTrips);

export default AddTrips;



// WEBPACK FOOTER //
// app/add_trips/add_trips.jsx